import * as React from 'react';

const Clock = ({fillColor = '#2961fa', width = 12.682, height = 12.682}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
    <g data-name="Group 233942" fill={fillColor}>
      <path
        data-name="Path 59156"
        d="M6.341 11.414a5.073 5.073 0 1 1 5.073-5.073 5.079 5.079 0 0 1-5.073 5.073ZM6.341 0a6.341 6.341 0 1 0 6.341 6.341A6.348 6.348 0 0 0 6.341 0Z"
      />
      <path
        data-name="Path 59157"
        d="M6.975 3.171H5.707V6.31a1.269 1.269 0 0 0 .372.9l2.165 2.306.9-.9L6.979 6.31V3.171Z"
      />
    </g>
  </svg>
);

export default Clock;
